import { useEffect, useState } from "react";
import {useVisibleComponentsContext, VISIBLE_COMPONENTS_ACTIONS} from "../../context/VisibleComponentsContext";

const options = {
    threshold: .25,
};

export const useOnScreen = (ref, componentName) => {
    const [isIntersecting, setIntersecting] = useState(false);
    const { dispatch } = useVisibleComponentsContext();

    function handleIntersection([entry]) {
        setIntersecting(entry.isIntersecting);
        if (entry.isIntersecting) {
        dispatch({ type: VISIBLE_COMPONENTS_ACTIONS.ADD_VISIBLE_COMPONENT, component: componentName });
        } else {
            dispatch({ type: VISIBLE_COMPONENTS_ACTIONS.REMOVE_VISIBLE_COMPONENT, component: componentName });
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection, options);

        if (ref.current) {
            observer.observe(ref.current);
        }
        
        return () =>{ 
            dispatch({ type: VISIBLE_COMPONENTS_ACTIONS.REMOVE_VISIBLE_COMPONENT, component: componentName });
            observer.disconnect()
        };
    }, [])

    return isIntersecting;
}
